// CHANGE PRODUCT BOTTOM STICKY BAR BUTTONS CONTENT

const subscriptionRadio = document.querySelector('.rc_radio__autodeliver');
const subscriptionPrice = document.querySelector('#rc_price_autodeliver');
const onetime = document.querySelector('.rc_radio__onetime');
const onetimePrice = document.querySelector('#rc_price_onetime');
// let checkoutLink = '/checkout';

const addToCartText = document.querySelector('#sticky-bar-add-to-cart-text');
const addToCartLabel = document.querySelector('#sticky-bar-add-to-cart-label');

if (subscriptionRadio || onetime) {
  subscriptionRadio.addEventListener('change', function() {
    if (subscriptionRadio.checked) {
      addToCartText.innerText = "Subscribe & Save";
      addToCartLabel.innerHTML = "<span class='custom-price'>" + subscriptionPrice.innerText + "</span>/mo. Cancel anytime";
//       checkoutLink = reChargeProcessCart();
    }
  });

  onetime.addEventListener('change', function() {
    if (onetime.checked) {
      addToCartText.innerText = "Add To Cart";
      addToCartLabel.innerHTML = "<span class='custom-price'>" + onetimePrice.innerText + "</span> One Time Purchase"; 
//       checkoutLink = '/checkout';
    }
  });
}

// COLLECTIONS GRID BG COLOR CHANGE AND TESTIMONIAL SECTION PADDING RESET

const collectionsGrid = document.querySelector('.collections-grid');
const customTestimonials = document.querySelector('.custom-testimonials');
const shippingHeroSections = document.querySelectorAll('.wrap-shipping-hero ');
const featuredBanner = document.querySelector('.wrap-featured-cta-banner');

if (collectionsGrid || customTestimonials || shippingHeroSections || featuredBanner) {
  collectionsGrid.parentNode.style.backgroundColor = '#F5F5F5';
  collectionsGrid.parentNode.style.paddingBottom = '4rem';

  customTestimonials.parentNode.style.paddingTop = '0';

  shippingHeroSections.forEach(function(section) {
      section.parentNode.style.backgroundColor = '#F5F5F5';
  });

  featuredBanner.parentNode.style.backgroundColor = '#F5F5F5';
}


const cButtonTexts = {
    subscribe: "Subscribe &amp; save",
    one_time: "Add to cart"

};

const sellingPlanDiscount = product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value;

function roundToTwo(num) {
    return +(Math.round(num + "e+2") + "e-2");
}

function changePriceElements(priceElements, newPrice) {
    [].forEach.call(priceElements, function(priceElement, i) {
        if (i !== 0) {
            priceElement.innerText = newPrice;
        }
    });
    var customPriceElements = document.querySelectorAll(".button-with-price span.custom-price");

    if (typeof (customPriceElements) != 'undefined' && customPriceElements != null) {
        [].forEach.call(customPriceElements, function(priceElement) {
            priceElement.innerText = newPrice;
        });
    }
}

function changeAddToCartButtonText(buttonText, labelText) {
    var addToCartText = document.querySelector('#sticky-bar-add-to-cart-text');
    var addToCartLabel = document.querySelector('#sticky-bar-add-to-cart-label');
    console.log(addToCartLabel);
    //     $('.sticky-bar-add-to-cart-text').html("test");
    addToCartText.innerText = buttonText;
    addToCartLabel.innerText = labelText;
    //     addToCartLabel.innerHTML = "<span class='custom-price'>" + subscriptionPrice.innerText + "</span>/mo. Cancel anytime";
    //   	$('.add-to-cart-and-quantity-container .button-no-price .cs-btn-cart').html(text);
}

window.handleBoldSubscriptionsPriceElements = function(priceElement, priceElements, price) {
    const ogPrice = priceElement.innerText;
    const quantity = Number($("#quantityInput").val());
    const selectedSellingGroup = $("input[name='bsub-selling-plan-group']:checked").val();
    const selectedSellingPlanId = $(`input[name='bsub-selling-plan-${selectedSellingGroup}']:checked`).val();
    const priceWithout$ = Number(price.replace(/[^0-9.-]+/g, ""));

    if (selectedSellingGroup !== 'once') {
        const newPrice = roundToTwo((priceWithout$ - (sellingPlanDiscount / 100) * priceWithout$)) * quantity;
        const newPriceString = `$${newPrice.toFixed(2)}`;
        changePriceElements(priceElements, newPriceString);
        //       changeAddToCartButtonText(cButtonTexts.subscribe);
        changeAddToCartButtonText("Subscribe & Save", "/mo. Cancel anytime");

    } else {
        const newPrice = roundToTwo(priceWithout$ * quantity);
        const newPriceString = `$${newPrice.toFixed(2)}`;
        changePriceElements(priceElements, newPriceString);
        //       changeAddToCartButtonText(cButtonTexts.one_time);
        changeAddToCartButtonText("Add To Cart", "One Time Purchase");

    }
}

//   Init Code
var waitForJQuery = setInterval(function() {
    if (typeof $ != 'undefined') {
        const priceElement = document.querySelector('#ProductPrice-product-template');
        const priceElements = document.querySelectorAll('#ProductPrice-product-template');
        const price = priceElement.innerText;
        window.handleBoldSubscriptionsPriceElements(priceElement, priceElements, price);

        $(`#product_form_${product.id}`).change(function() {
            window.handleBoldSubscriptionsPriceElements(priceElement, priceElements, price);
        });

        clearInterval(waitForJQuery);
    }
}, 10);
